import { render } from "./PerfilPage.vue?vue&type=template&id=cee4b59e"
import script from "./PerfilPage.vue?vue&type=script&lang=js"
export * from "./PerfilPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__